export const AuditPeriods = [
    {
        id: 1,
        description: 'Jan',
    },
    {
        id: 2,
        description: 'Feb',
    },
    {
        id: 3,
        description: 'Mar',
    },
    {
        id: 4,
        description: 'Apr',
    },
    {
        id: 5,
        description: 'May',
    },
    {
        id: 6,
        description: 'Jun',
    },
    {
        id: 7,
        description: 'Jul',
    },
    {
        id: 8,
        description: 'Aug',
    },
    {
        id: 9,
        description: 'Sep',
    },
    {
        id: 10,
        description: 'Oct',
    },
    {
        id: 11,
        description: 'Nov',
    },
    {
        id: 12,
        description: 'Dec',
    }
]

export default AuditPeriods